import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { peopleSpeak, trafficCone } from 'assets/icon';
import { Col, Row, Typography } from '../alf-design';
import { logo, maintenance } from '../../assets/img';
import Background from './Background';
import Footer from './Footer';
import './MaintenancePage.css';

const MaintenancePage = () => {
  useEffect(() => {
    datadogRum.addAction('maintenance.page.viewed');
  }, []);

  const renderCircleIcon = (icon) => <img alt="" src={icon} className="icon" />;

  return (
    <Background>
      <main id="public-main-content" role="main">
        <Row className="maintenanceLogo">
          <img src={logo} alt="mySlide" className="logo" />
        </Row>
        <Row className="maintenancePage">
          <Col lg={12} className="panelLeft">
            <img
              src={maintenance}
              alt="maintenanceImg"
              className="maintenanceImg"
            />
          </Col>
          <Col lg={12} className="panelRight">
            <Col xs={24} md={24} className="rightItems">
              <Col xs={5} md={5} className="circleIcon">
                {renderCircleIcon(trafficCone)}
              </Col>
              <Col xs={19} md={19}>
                <Typography type="h2" component="h2" className="item-subtitle">
                  System Maintenance
                </Typography>
                <Typography component="p" className="item-paragraph">
                  mySlide is undergoing scheduled maintenance. <br />
                  Access and tools will not be available during this time.
                </Typography>
              </Col>
              <Col xs={24} md={24} className="customerService">
                <Col xs={5} md={5} className="circleIcon">
                  {renderCircleIcon(peopleSpeak)}
                </Col>
                <Col xs={19} md={19}>
                  <Typography
                    type="h2"
                    component="h2"
                    className="item-subtitle"
                  >
                    Customer Service
                  </Typography>
                  <Typography component="p" className="item-paragraph">
                    If you have any questions or need help with your account,
                    call customer service at (800) 748-2030. Available Monday -
                    Friday, 8am - 5pm EST
                  </Typography>
                </Col>
              </Col>
            </Col>
          </Col>
        </Row>
      </main>
      <Footer />
    </Background>
  );
};

export default MaintenancePage;
